module.exports = __webpack_public_path__ + "static/media/Windridge-Place-Declaration-of-Covenants.6f4907de.pdf";